<template>
  <div class="info-card-container">
    <div class="left-content" :style="{ width: $slots['right-content'] ? 'auto' : '100%' }">
      <div class="card-header">
        <div class="title-section">
          <mf-icon size="20" fill color="cinza-0" :icon="icons[cardKey]" />
          <span> {{ title }} </span>
        </div>
        <div v-if="tooltip">
          <mf-tooltip max-width="300" top variant="secondary">
            <template #activator="{ on }">
              <mf-icon dense color="cinza-l10" icon="info" />
            </template>
            {{ tooltip }}
          </mf-tooltip>
        </div>
      </div>
      <div v-if="description" class="description-section">
        <span> {{ description }} </span>
      </div>
      <slot name="additional-content"></slot>
    </div>
    <div v-if="$slots['right-content']" style="flex: 1">
      <slot name="right-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    hasSlot: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    cardKey: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    icons() {
      return {
        'validity-period': 'calendar_today',
        'campaign-template': 'mobile_friendly',
        'campaign-format': 'sell',
        'campaign-industry': 'factory',
        'voucher-type': 'confirmation_number',
        'cashback-expiration-date': 'calendar_today',
        'proposal-deadline': 'calendar_today',
        target: 'group',
        communication: 'chat',
        units: 'store',
        products: 'shopping_basket',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.info-card-container {
  padding: 16px 12px;
  background-color: $cinza-l90;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 42px;

  .left-content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .card-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .title-section {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-content: center;
        span {
          color: $cinza-0;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
        }
      }
    }
    .description-section {
      span {
        color: $cinza-d10;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0em;
      }
    }
  }
}
</style>
